import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const TabNavigation = ({ id }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const handleTabClick = (tabName) => {
        navigate(tabName);
    };

    return (
        <div className="tab-navigation-game">
            <div className="tab-game-title">Bao lô</div>
            <div className={location.pathname === `/xsmn/lo2/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/lo2/${id}`)}>
                Lô 2 số
            </div>
            {/*<div className={location.pathname === `/xsmn/lo2dau/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/lo2dau/${id}`)}>
                Lô 2 số đầu
            </div>*/}
            <div className={location.pathname === `/xsmn/lo2so1k/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/lo2so1k/${id}`)}>
                Lô 2 số 1K
            </div>
            <div className={location.pathname === `/xsmn/lo3/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/lo3/${id}`)}>
                Lô 3 số
            </div>
            <div className={location.pathname === `/xsmn/lo4/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/lo4/${id}`)}>
                Lô 4 số
            </div>

            <div className="tab-game-title">Lô xiên</div>
            <div className={location.pathname === `/xsmn/loxien2/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/loxien2/${id}`)}>
                Lô xiên 2
            </div>
            <div className={location.pathname === `/xsmn/loxien3/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/loxien3/${id}`)}>
                Lô xiên 3
            </div>
            <div className={location.pathname === `/xsmn/loxien4/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/loxien4/${id}`)}>
                Lô xiên 4
            </div>

            <div className="tab-game-title">Đánh đề</div>
            <div className={location.pathname === `/xsmn/dedb/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/dedb/${id}`)}>
                Đề đặc biệt
            </div>
            <div className={location.pathname === `/xsmn/dedaudb/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/dedaudb/${id}`)}>
                Đề đầu đặc biệt
            </div>
            <div className={location.pathname === `/xsmn/dedauduoi/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/dedauduoi/${id}`)}>
                Đề đầu đuôi
            </div>
            {/*<div className={location.pathname === `/xsmn/degiai7/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/degiai7/${id}`)}>
                Đề giải 7
            </div>
            <div className={location.pathname === `/xsmn/de1/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/de1/${id}`)}>
                Đề giải nhất
            </div>
            <div className={location.pathname === `/xsmn/dedau1/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/dedau1/${id}`)}>
                Đề đầu giải nhất
            </div>*/}

            <div className="tab-game-title">Đầu đuôi</div>
            <div className={location.pathname === `/xsmn/dau/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/dau/${id}`)}>
                Đầu
            </div>
            <div className={location.pathname === `/xsmn/duoi/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/duoi/${id}`)}>
                Đuôi
            </div>

            <div className="tab-game-title">3 càng</div>
            <div className={location.pathname === `/xsmn/3cangdau/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/3cangdau/${id}`)}>
                3 càng đầu
            </div>
            <div className={location.pathname === `/xsmn/3cangdb/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/3cangdb/${id}`)}>
                3 càng đặc biệt
            </div>
            {/*<div className={location.pathname === `/xsmn/3cang1/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/3cang1/${id}`)}>
                3 càng giải nhất
            </div>*/}
            <div className={location.pathname === `/xsmn/3cangdauduoi/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/3cangdauduoi/${id}`)}>
                3 càng đầu đuôi
            </div>

            <div className="tab-game-title">4 càng</div>
            <div className={location.pathname === `/xsmn/4cangdb/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/4cangdb/${id}`)}>
                4 càng đặc biệt
            </div>

            <div className="tab-game-title">Lô trượt</div>
            <div className={location.pathname === `/xsmn/truotxien4/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/truotxien4/${id}`)}>
                Trượt xiên 4
            </div>
            <div className={location.pathname === `/xsmn/truotxien8/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/truotxien8/${id}`)}>
                Trượt xiên 8
            </div>
            <div className={location.pathname === `/xsmn/truotxien10/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/truotxien10/${id}`)}>
                Trượt xiên 10
            </div>

            {/*<div className="tab-game-title">Trò chơi thú vị</div>
            <div className={location.pathname === `/xsmn/lo2db/${id}` ? "active" : ""} onClick={() => handleTabClick(`/xsmn/lo2db/${id}`)}>
                Lô 2 số giải ĐB
            </div>*/}
        </div>
    );
};

export default TabNavigation;
